module.exports = __webpack_public_path__ + "static/media/sample.dce59db5.png";